<template>
  <Loader :loader="loaderState" />
  <main class="w-full flex justify-center">
    <section v-if="isFirstTimeCourse">
      <FirstTimeCourse
        @onCloseFirstTimeCourse="courseStore.setCourseInitiated()"
      />
    </section>
    <GenericAlert v-else />
  </main>
</template>

<script lang="ts">
import { ChatBotService } from "@/components/ChatBot/chat-bot.service";
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { GenericsUtils } from "@/utils/generics.util";
import { defineAsyncComponent, defineComponent } from "vue";
import { useAlertStore } from "@/store/adaptative/alert";
import { useAdaptProgressStore } from "@/store/adaptative/adapt-progress";
import { useAdaptCourseStore } from "@/store/adaptative/adapt-course";
import { ELoader, useAdaptLoaderStore } from "@/store/adaptative/adapt-loader";
const FirstTimeCourse = defineAsyncComponent(
  () => import("./FirstTimeCourse/first-time-course.vue")
);
const GenericAlert = defineAsyncComponent(
  () => import("./GenericAlert/generic-alert.vue")
);
export default defineComponent({
  name: "alertsCourse",
  components: {
    FirstTimeCourse,
    GenericAlert,
  },

  setup() {
    const progressStore = useAdaptProgressStore;
    const alertStore = useAlertStore;
    const courseStore = useAdaptCourseStore;
    const loaderStore = useAdaptLoaderStore;

    return {
      progressStore,
      alertStore,
      courseStore,
      loaderStore,
    };
  },
  computed: {
    chatbotService(): ChatBotService {
      return new ChatBotService();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    isFirstTimeCourse(): boolean {
      return this.courseStore?.firstTime ?? !this.courseStore.course.hasStarted;
    },
    loaderState() {
      return this.alertStore[ELoader.ALERT];
    },
  },
  data() {
    return {
      bigTitle: "" as string,
      title: "" as string,
      message: "" as string,
      homeroAvatar: "" as string,
      iconTitle: "" as string,
      buttons: [] as any,
      loader: false as boolean,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
    };
  },
  props: {
    data: {
      required: true,
      type: Object as any,
    },
    type: {
      type: String,
      default: "intro",
    },
    firstTimeCourse: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
